import axios from "axios";
import { logoutUser, refreshAccessToken } from "./authHelpers";
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: API_URL,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // If 401 error and not a retry request and not a login/refresh request
    if (error.response?.status === 401 && 
        !originalRequest._retry && 
        !originalRequest.url.includes('/refresh') &&
        !originalRequest.url.includes('/login')) {
      
      originalRequest._retry = true;
      
      try {
        await refreshAccessToken();
   
          // Retry the original request with new token
          return axiosInstance(originalRequest);
        
      } catch (refreshError) {
        console.error('Token refresh failed', refreshError);
        await logoutUser();
        return Promise.reject(refreshError);
      }
    }
    
    // For other errors or if refresh failed
    if (error.response?.status === 403) {
      // Handle forbidden error (e.g., redirect to login)
      await logoutUser();
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;